// extracted by mini-css-extract-plugin
module.exports = {"btnBlue":"_loading_btnBlue_1ChoO","btnBlueOutline":"_loading_btnBlueOutline_5WPid","invalidCoding":"_loading_invalidCoding_1VP7B","loadingIcon":"_loading_loadingIcon_2KEMq"};